<template>
        <WidgetTitle 
            :styles="content.styles"
            :translation="content.translation"
            :upload="content.upload"
        >
            <div v-for="(video, index) in videos" :key="index" class="d-flex flex-wrap my-5" :class="rowReverse(index)">
                <div 
                    id="nch--home-video-container" 
                    class="col-lg-5 col-md-6 col-sm-12 px-0 iframe__box"
                    v-html="video.settings.iframe"
                ></div>
                <div class="col-lg-7 col-md-6 col-sm-12 ">
                    <h1 
                        class="mb-0 mt-3 mx-3"
                        :style="{ color: video.settings.title.color }"
                    >
                        {{video.translation.title}}
                    </h1>
                    <pre 
                        class="my-3 mx-3 text-justify"
                        :style="{ color: video.settings.description.color, whiteSpace: 'pre-line' }"
                    >
                        {{video.translation.description}}
                    </pre>
                </div>
            </div>
        </WidgetTitle>
</template>

<script>
import WidgetTitle from '../../components/Common/WidgetTitle'
export default {
    name: 'HomeVideos',
    components: {
        WidgetTitle
    },
    props: {
        content: {
            type: Object,
            required: true
        },
    },
    data() {
        return {
            videos: this.content.contents
        }
    },
    methods: {
        rowReverse(index) {
            if (index % 2 !== 0) return 'flex-row-reverse'
        }
    }
}
</script>

<style>
    .iframe__box {
        box-shadow: 0 10px 25px 0 rgba(0,0,0,.3);
    }
</style>
